import {Component, Input, OnInit} from '@angular/core';
import {DialogConfig} from "../../../../../core/components/dialog/dialog-config";
import {DialogRef} from "../../../../../core/components/dialog/dialog-ref";
import {DocumentoAllegato} from "../../../../models/documento-allegato";
import { MarkDocumentService } from '../../services/mark-document.service';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';

@Component({
  selector: 'app-mark-document-dialog',
  templateUrl: './mark-document-dialog.component.html',
  styleUrls: ['./mark-document-dialog.component.css']
})
export class MarkDocumentDialogComponent implements OnInit {

  @Input() document: DocumentoAllegato;
  @Input() idFascicolo: string;
 


  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private documentoService: MarkDocumentService,
    public viewManager: ViewManagerService
  ) {
  }

  public ngOnInit() {
    console.log("[ngOnInit]");
    this.document = this.dialogConfig.data.document;
    this.idFascicolo = this.dialogConfig.data.idFascicolo;
  }

  protected doClose() {
    this.dialogRef.close({modalEvent : true});
  }

  onSubmit(payload: any) {
  // Logica per inviare la richiesta di timbratura al backend
    this.documentoService.timbraDocumento(payload).subscribe((response) => {
      console.log("Documento timbrato con successo", response);
      this.docAdded(response, payload);
      this.dialogRef.close({modalEvent: true, response});
    });
  }

  private docAdded(response: any, request: any) {
    if (response.returnCode === 'OK') {
      console.log("Documento aggiunto correttamente", response);
      this.viewManager.updateDocumentazione(response.documenti);
    }
  }



}
